import { computeMergedTheme, type MergedTheme } from '@owner/theme'
import get from 'lodash/get'
import { inject, computed, type ComputedRef } from 'vue'

import { useActiveBrand } from '@/core/store'
import globalStore from '@/store'

export const useMergedTheme = (): ComputedRef<MergedTheme | undefined> => {
  const { mergedTheme: coreMergedTheme } = useActiveBrand()

  const brandThemePath = inject('brandThemePath') as string
  const storeModule = inject('storeModule') as string

  return computed(() => {
    if (brandThemePath) {
      const localTheme = get(
        globalStore.getters[`${storeModule}/currentResource`],
        brandThemePath
      )

      if (localTheme) {
        return computeMergedTheme(localTheme)
      }

      return coreMergedTheme.value
    } else {
      return coreMergedTheme.value
    }
  })
}
